import posItems from './posItems';
const posSource = {
  id: 1,
  name: "Store 1",
  items: posItems,   // POS items
  posSourceUrl: "https://api.squareup.com/pos/realityi/store1",
  isActive: true
}

export default posSource;